/**
 * Endpoint methods related to Coupons Feature
*/

import API from "./Api";

export default {

    /**
     * Gets the Coupons related to the Logged-In Instance
     */
    async getAllOwn() {
        return API.get("/coupon/readallown", "COOKIE_TOKEN_SESSION");
      },

    /**
     * Creates a new Coupon for the Logged-In Instance
     */

    async create(body) {
        return API.post("/coupon/create", body, "MOODLE_SESSION_JSON");
    },
}